<template>
  <div class="table-responsive-lg">
    <table class="table mt-4 text-morado-claro">
      <thead>
        <tr class="text-white bg-morado-oscuro">
          <th scope="col">Establecimiento</th>
          <th scope="col" class="text-center d-none d-lg-table-cell">
            Dependencia
          </th>
          <th scope="col" class="text-center d-none d-lg-table-cell">
            Matriculados
          </th>
          <th scope="col" class="text-center d-none d-lg-table-cell">
            Alumnos por curso
          </th>
          <th scope="col" class="d-none d-lg-table-cell">Dirección</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          :class="{ 'bg-light': index % 2 === 1 }"
          v-for="(establecimiento, index) in arregloEstablecimientos"
          :key="establecimiento.nombres + '-' + index"
        >
          <th
            scope="row"
            class="align-middle text-nowrap"
            :id="establecimiento.rbd + '-genero'"
          >
            {{ establecimiento.nombre }}
            <!--ICONOS-->
            <b-row class="w-80 mx-0">
              <!--COPAGO-->
              <b-col cols="auto" class="px-0 border-right">
                <div
                  class="btn-ficha d-flex rounded-circle my-0 d-inline-block mx-auto h6"
                  :class="{
                    'text-azul-medio': !esGratuito(establecimiento.etiquetas),
                    'text-gris-light': esGratuito(establecimiento.etiquetas)
                  }"
                  v-b-tooltip.hover
                  :title="tooltipCopago(esGratuito(establecimiento.etiquetas))"
                >
                  <span class="align-self-center mx-auto">
                    <FontAwesomeIcon icon="dollar-sign"></FontAwesomeIcon>
                  </span>
                </div>
              </b-col>
              <!--genero-->
              <b-col cols="auto" class="px-0 border-right">
                <div
                  class="btn-ficha text-azul-medio d-flex rounded-circle my-0 d-inline-block mx-auto h6"
                  v-b-tooltip.hover
                  :title="
                    tooltipGenero(
                      establecimiento.informacionInstitucional.regimen
                    )
                  "
                >
                  <span class="align-self-center mx-auto">
                    <FontAwesomeIcon
                      v-if="
                        establecimiento.informacionInstitucional.regimen ===
                          'Hombres'
                      "
                      icon="male"
                    ></FontAwesomeIcon>
                    <FontAwesomeIcon
                      v-else-if="
                        establecimiento.informacionInstitucional.regimen ===
                          'Mujeres'
                      "
                      icon="female"
                    ></FontAwesomeIcon>
                    <FontAwesomeIcon v-else icon="restroom"></FontAwesomeIcon>
                  </span>
                </div>
              </b-col>
              <!--SEP-->
              <b-col cols="auto" class="px-0 border-right">
                <div
                  :id="rbd + '-sep'"
                  v-b-tooltip.hover
                  :title="tooltipSep(esSep(establecimiento.etiquetas))"
                  class="btn-ficha d-flex d-inline-block mx-auto my-0"
                  :class="{
                    'text-azul-medio font-weight-bold': esSep(
                      establecimiento.etiquetas
                    ),
                    'text-gris-light': !esSep(establecimiento.etiquetas)
                  }"
                >
                  <span class="align-self-center mx-auto">SEP</span>
                </div>
              </b-col>
              <!--PIE-->
              <b-col cols="auto" class="px-0">
                <div
                  :id="rbd + '-pie'"
                  v-b-tooltip.hover
                  :title="tooltipPie(esPie(establecimiento.etiquetas))"
                  class="btn-ficha d-flex d-inline-block mx-auto my-0"
                  :class="{
                    'text-azul-medio font-weight-bold': esPie(
                      establecimiento.etiquetas
                    ),
                    'text-gris-light': !esPie(establecimiento.etiquetas)
                  }"
                >
                  <span class="align-self-center mx-auto">PIE</span>
                </div>
              </b-col>
            </b-row>
            <!--FIN ICONOS-->
          </th>
          <td class="align-middle text-center d-none d-lg-table-cell">
            {{ textoDependencia(establecimiento) }}
          </td>
          <td class="align-middle text-center d-none d-lg-table-cell">
            {{ establecimiento.informacionInstitucional.alumnosMatriculados }}
          </td>
          <td class="align-middle text-center d-none d-lg-table-cell">
            {{
              establecimiento.informacionInstitucional.promedioAlumnosPorCurso
            }}
          </td>
          <td class="align-middle d-none d-lg-table-cell">
            {{ establecimiento.sedes[0].direccion.calle }}
          </td>
          <td class="align-middle">
            <router-link
              :to="'/establecimiento/' + establecimiento.rbd"
              class="btn btn-yellow font-weight-bold text-uppercase"
              >Ver</router-link
            >
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-show="establecimientos.length > 0"
      v-model="pagina"
      :per-page="datosPorPagina"
      :total-rows="establecimientos.length"
      align="center"
    >
    </b-pagination>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faRestroom,
  faMale,
  faFemale
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faRestroom, faMale, faFemale);
export default {
  props: {
    establecimientos: {
      type: Array,
      required: true
    }
  },
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      pagina: 1,
      arregloEstablecimientos: [],
      datosPorPagina: 10,
      rbd: ""
    };
  },
  watch: {
    pagina() {
      this.paginaEstablecimientos(this.establecimientos, this.pagina);
    },
    establecimientos() {
      this.paginaEstablecimientos(this.establecimientos, this.pagina);
    }
  },
  methods: {
    //calcula la pagina nueva del
    paginaEstablecimientos: function(establecimientos, pagina) {
      let arreglo = [];
      if (establecimientos.length > 0) {
        let inicio = (pagina - 1) * this.datosPorPagina;
        let final =
          pagina * this.datosPorPagina > establecimientos.length
            ? establecimientos.length
            : pagina * this.datosPorPagina;
        arreglo = establecimientos.slice(inicio, final);
      }
      this.arregloEstablecimientos = arreglo;
    },
    //calcula texto para campo dependencia
    textoDependencia: function(establecimiento) {
      switch (establecimiento.dependencia) {
        case "PARTICULAR SUBVENCIONADO":
          return "Particular subvencionado";
        default:
          return "Público";
      }
    },
    tooltipGenero: function(genero) {
      switch (genero) {
        case "Hombres":
          return "Sólo hombres";
        case "Mujeres":
          return "Sólo mujeres";
        default:
          return "Mixto";
      }
    },
    tooltipCopago: function(gratuito) {
      return gratuito ? "Sin copago" : "Con copago";
    },
    tooltipSep: function(esSep) {
      return esSep
        ? "Con Subvención Escolar Preferencial"
        : "Sin Subvención Escolar Preferencial";
    },
    tooltipPie: function(esPie) {
      return esPie
        ? "Con Programa de Integración Escolar"
        : "Sin Programa de Integración Escolar";
    },
    esGratuito: function(etiquetas) {
      if (etiquetas !== undefined) {
        return etiquetas.includes("GRATUITO");
      } else {
        return false;
      }
    },
    esSep(etiquetas) {
      if (etiquetas !== undefined) {
        return etiquetas.includes("SEP");
      } else {
        return false;
      }
    },
    esPie(etiquetas) {
      if (etiquetas !== undefined) {
        return etiquetas.includes("PIE");
      } else {
        return false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/busqueda/establecimientos/ListaEstablecimientos.vue